module.exports = __webpack_public_path__ + "media/images/slider_h1_sp_02-33f24337d00c2ba362f610d416ba3414.png";